// extracted by mini-css-extract-plugin
export default {"tree":"FiltersCatalog_tree__djdt5","filter":"FiltersCatalog_filter__83Che"};